import React from 'react';
const Spinner = (props) => {
    if(props.spinnerExtras)
    return <div className="lds-ring"><div></div><div></div><div></div><div></div></div> ;

    return <div className={"LoaderWrapper " + (props.size? props.size: "")}><div className={`Loader ${props.className || ""}`}>Loading...</div></div>
};

export default Spinner;